export default "__VITE_ASSET__dde6a638__"